import type { SoQuyTienMatRow } from '@/types/schemas';

export type CashBookDocumentEntryType = 'PHIEU_THU' | 'PHIEU_CHI' | 'GIAY_BAO_CO' | 'GIAY_BAO_NO';

export interface CashBookDocumentEntryState {
  documentUuid: string;
  documentType: string;
  entryType: CashBookDocumentEntryType;
}

const DOCUMENT_ENTRY_TYPE_BY_CODE: Record<string, CashBookDocumentEntryType> = {
  PHIEU_THU: 'PHIEU_THU',
  PHIEU_CHI: 'PHIEU_CHI',
  GIAY_BAO_CO: 'GIAY_BAO_CO',
  GIAY_BAO_NO: 'GIAY_BAO_NO'
};

const readString = (value: unknown) => (typeof value === 'string' ? value.trim() : '');

export const resolveCashBookDocumentEntry = (
  row: Partial<SoQuyTienMatRow> | null | undefined
): CashBookDocumentEntryState | null => {
  if (!row || typeof row !== 'object') return null;

  const documentUuid = readString(row.document_uuid) || readString(row.uuid);
  const documentType = readString(row.document_type) || readString(row.ma_ct);
  const soCt = readString(row.so_ct);
  const entryType = DOCUMENT_ENTRY_TYPE_BY_CODE[documentType];

  if (!documentUuid || !documentType || !soCt || !entryType) {
    return null;
  }

  return {
    documentUuid,
    documentType,
    entryType
  };
};
